/* Auto-generated from Figma HiH header illustration — vector motifs for crisp rendering */
import type { CSSProperties } from "react";
import motif01 from "@assets/images/hih-ribbon/motif-01.svg";
import motif02 from "@assets/images/hih-ribbon/motif-02.svg";
import motif03 from "@assets/images/hih-ribbon/motif-03.svg";
import motif04 from "@assets/images/hih-ribbon/motif-04.svg";
import motif05 from "@assets/images/hih-ribbon/motif-05.svg";
import motif06 from "@assets/images/hih-ribbon/motif-06.svg";
import motif07 from "@assets/images/hih-ribbon/motif-07.svg";
import motif08 from "@assets/images/hih-ribbon/motif-08.svg";
import motif09 from "@assets/images/hih-ribbon/motif-09.svg";
import motif10 from "@assets/images/hih-ribbon/motif-10.svg";
import motif11 from "@assets/images/hih-ribbon/motif-11.svg";
import motif12 from "@assets/images/hih-ribbon/motif-12.svg";
import motif13 from "@assets/images/hih-ribbon/motif-13.svg";
import motif14 from "@assets/images/hih-ribbon/motif-14.svg";
import motif15 from "@assets/images/hih-ribbon/motif-15.svg";
import motif16 from "@assets/images/hih-ribbon/motif-16.svg";
import motif17 from "@assets/images/hih-ribbon/motif-17.svg";
import motif18 from "@assets/images/hih-ribbon/motif-18.svg";
import motif19 from "@assets/images/hih-ribbon/motif-19.svg";
import motif20 from "@assets/images/hih-ribbon/motif-20.svg";
import motif21 from "@assets/images/hih-ribbon/motif-21.svg";
import motif22 from "@assets/images/hih-ribbon/motif-22.svg";
import motif23 from "@assets/images/hih-ribbon/motif-23.svg";
import motif24 from "@assets/images/hih-ribbon/motif-24.svg";
import motif25 from "@assets/images/hih-ribbon/motif-25.svg";
import motif26 from "@assets/images/hih-ribbon/motif-26.svg";
import motif27 from "@assets/images/hih-ribbon/motif-27.svg";
import motif28 from "@assets/images/hih-ribbon/motif-28.svg";
import motif29 from "@assets/images/hih-ribbon/motif-29.svg";
import motif30 from "@assets/images/hih-ribbon/motif-30.svg";
import motif31 from "@assets/images/hih-ribbon/motif-31.svg";
import motif32 from "@assets/images/hih-ribbon/motif-32.svg";
import motif33 from "@assets/images/hih-ribbon/motif-33.svg";
import motif34 from "@assets/images/hih-ribbon/motif-34.svg";
import motif35 from "@assets/images/hih-ribbon/motif-35.svg";
import motif36 from "@assets/images/hih-ribbon/motif-36.svg";
import motif37 from "@assets/images/hih-ribbon/motif-37.svg";
import motif38 from "@assets/images/hih-ribbon/motif-38.svg";
import motif39 from "@assets/images/hih-ribbon/motif-39.svg";
import motif40 from "@assets/images/hih-ribbon/motif-40.svg";

type Motif = {
  top: string;
  right: string;
  bottom: string;
  left: string;
  src: string;
  transform?: string;
};

const MOTIFS: Motif[] = [
  { top: "0.02%", right: "86.22%", bottom: "1.02%", left: "12.59%", src: motif08 },
  { top: "0.02%", right: "28.98%", bottom: "1.02%", left: "69.83%", src: motif08 },
  { top: "0", right: "92%", bottom: "1.01%", left: "6.81%", src: motif05 },
  { top: "0", right: "44.78%", bottom: "1.01%", left: "54.04%", src: motif05 },
  { top: "0.02%", right: "90.07%", bottom: "1.02%", left: "9.33%", src: motif07 },
  { top: "0.02%", right: "32.83%", bottom: "1.02%", left: "66.57%", src: motif07 },
  { top: "0.02%", right: "81.98%", bottom: "1.02%", left: "17.43%", src: motif14 },
  { top: "0.02%", right: "60.93%", bottom: "1.02%", left: "38.48%", src: motif14 },
  { top: "0.02%", right: "95.19%", bottom: "1.02%", left: "4.22%", src: motif03 },
  { top: "0.02%", right: "47.96%", bottom: "1.02%", left: "51.44%", src: motif03 },
  { top: "0.02%", right: "93.93%", bottom: "1.02%", left: "4.89%", src: motif04, transform: "scaleX(-1)" },
  { top: "0.02%", right: "46.7%", bottom: "1.02%", left: "52.11%", src: motif04, transform: "scaleX(-1)" },
  { top: "0.02%", right: "98.81%", bottom: "1.02%", left: "0", src: motif10 },
  { top: "0.02%", right: "51.59%", bottom: "1.02%", left: "47.22%", src: motif10 },
  { top: "0.01%", right: "90.74%", bottom: "1.02%", left: "8.07%", src: motif06, transform: "rotate(180deg)" },
  { top: "0.01%", right: "33.5%", bottom: "1.02%", left: "65.31%", src: motif06, transform: "rotate(180deg)" },
  { top: "0.02%", right: "88.15%", bottom: "1.02%", left: "10.66%", src: motif17 },
  { top: "0.02%", right: "30.91%", bottom: "1.02%", left: "67.9%", src: motif17 },
  { top: "0.02%", right: "84.94%", bottom: "1.02%", left: "13.85%", src: motif09 },
  { top: "0.02%", right: "27.7%", bottom: "1.02%", left: "71.09%", src: motif09 },
  { top: "0.02%", right: "96.52%", bottom: "1.02%", left: "2.59%", src: motif11 },
  { top: "0.02%", right: "49.3%", bottom: "1.02%", left: "49.81%", src: motif11 },
  { top: "0.02%", right: "83.31%", bottom: "1.02%", left: "15.8%", src: motif12, transform: "scaleX(-1)" },
  { top: "0.02%", right: "62.26%", bottom: "1.02%", left: "36.85%", src: motif12, transform: "scaleX(-1)" },
  { top: "0.02%", right: "97.48%", bottom: "1.02%", left: "1.93%", src: motif02 },
  { top: "0.02%", right: "50.26%", bottom: "1.02%", left: "49.15%", src: motif02 },
  { top: "0.02%", right: "98.15%", bottom: "1.02%", left: "1.26%", src: motif01 },
  { top: "0.02%", right: "50.93%", bottom: "1.02%", left: "48.48%", src: motif01 },
  { top: "0.02%", right: "82.65%", bottom: "1.02%", left: "16.76%", src: motif15 },
  { top: "0.02%", right: "61.59%", bottom: "1.02%", left: "37.81%", src: motif15 },
  { top: "0.02%", right: "95.85%", bottom: "1.02%", left: "3.56%", src: motif13 },
  { top: "0.02%", right: "48.63%", bottom: "1.02%", left: "50.78%", src: motif13 },
  { top: "0.02%", right: "89.41%", bottom: "1.02%", left: "10%", src: motif39 },
  { top: "0.02%", right: "32.17%", bottom: "1.02%", left: "67.24%", src: motif39 },
  { top: "0.02%", right: "93.26%", bottom: "1.02%", left: "6.15%", src: motif18 },
  { top: "0.02%", right: "46.04%", bottom: "1.02%", left: "53.37%", src: motif18 },
  { top: "0.02%", right: "87.48%", bottom: "1.02%", left: "11.92%", src: motif19 },
  { top: "0.02%", right: "30.24%", bottom: "1.02%", left: "69.16%", src: motif19 },
  { top: "0.02%", right: "84.28%", bottom: "1.02%", left: "15.13%", src: motif16 },
  { top: "0.02%", right: "63.22%", bottom: "1.02%", left: "36.18%", src: motif16 },
  { top: "0.01%", right: "67.15%", bottom: "1.02%", left: "31.67%", src: motif20, transform: "rotate(180deg)" },
  { top: "0.01%", right: "38.02%", bottom: "1.02%", left: "60.8%", src: motif20, transform: "rotate(180deg)" },
  { top: "0", right: "79.46%", bottom: "1.01%", left: "19.35%", src: motif21, transform: "rotate(180deg)" },
  { top: "0", right: "58.41%", bottom: "1.01%", left: "40.41%", src: motif21, transform: "rotate(180deg)" },
  { top: "0.01%", right: "63.89%", bottom: "1.02%", left: "35.52%", src: motif22, transform: "rotate(180deg)" },
  { top: "0.01%", right: "34.76%", bottom: "1.02%", left: "64.65%", src: motif22, transform: "rotate(180deg)" },
  { top: "0.01%", right: "71.98%", bottom: "1.02%", left: "27.43%", src: motif23, transform: "rotate(180deg)" },
  { top: "0.01%", right: "42.85%", bottom: "1.02%", left: "56.55%", src: motif23, transform: "rotate(180deg)" },
  { top: "0.01%", right: "76.87%", bottom: "1.02%", left: "22.54%", src: motif24, transform: "rotate(180deg)" },
  { top: "0.01%", right: "55.82%", bottom: "1.02%", left: "43.59%", src: motif24, transform: "rotate(180deg)" },
  { top: "0.01%", right: "77.54%", bottom: "1.02%", left: "21.28%", src: motif25, transform: "scaleX(-1) rotate(180deg)" },
  { top: "0.01%", right: "56.48%", bottom: "1.02%", left: "42.33%", src: motif25, transform: "scaleX(-1) rotate(180deg)" },
  { top: "0.01%", right: "72.65%", bottom: "1.02%", left: "26.17%", src: motif26, transform: "rotate(180deg)" },
  { top: "0.01%", right: "43.52%", bottom: "1.02%", left: "55.3%", src: motif26, transform: "rotate(180deg)" },
  { top: "0.02%", right: "80.72%", bottom: "1.02%", left: "18.09%", src: motif27 },
  { top: "0.02%", right: "59.67%", bottom: "1.02%", left: "39.15%", src: motif27 },
  { top: "0.01%", right: "65.22%", bottom: "1.02%", left: "33.59%", src: motif28, transform: "rotate(180deg)" },
  { top: "0.01%", right: "36.09%", bottom: "1.02%", left: "62.72%", src: motif28, transform: "rotate(180deg)" },
  { top: "0.01%", right: "68.41%", bottom: "1.02%", left: "30.39%", src: motif29, transform: "rotate(180deg)" },
  { top: "0.01%", right: "39.28%", bottom: "1.02%", left: "59.52%", src: motif29, transform: "rotate(180deg)" },
  { top: "0.01%", right: "75.24%", bottom: "1.02%", left: "23.87%", src: motif30, transform: "rotate(180deg)" },
  { top: "0.01%", right: "54.19%", bottom: "1.02%", left: "44.93%", src: motif30, transform: "rotate(180deg)" },
  { top: "0.01%", right: "70.35%", bottom: "1.02%", left: "28.76%", src: motif31, transform: "scaleX(-1) rotate(180deg)" },
  { top: "0.01%", right: "41.22%", bottom: "1.02%", left: "57.89%", src: motif31, transform: "scaleX(-1) rotate(180deg)" },
  { top: "0.01%", right: "74.57%", bottom: "1.02%", left: "24.83%", src: motif32, transform: "rotate(180deg)" },
  { top: "0.01%", right: "53.52%", bottom: "1.02%", left: "45.89%", src: motif32, transform: "rotate(180deg)" },
  { top: "0.01%", right: "73.91%", bottom: "1.02%", left: "25.5%", src: motif33, transform: "rotate(180deg)" },
  { top: "0.01%", right: "52.85%", bottom: "1.02%", left: "46.55%", src: motif33, transform: "rotate(180deg)" },
  { top: "0.01%", right: "71.32%", bottom: "1.02%", left: "28.09%", src: motif34, transform: "rotate(180deg)" },
  { top: "0.01%", right: "42.19%", bottom: "1.02%", left: "57.22%", src: motif34, transform: "rotate(180deg)" },
  { top: "0.01%", right: "76.2%", bottom: "1.02%", left: "23.2%", src: motif35, transform: "rotate(180deg)" },
  { top: "0.01%", right: "55.15%", bottom: "1.02%", left: "44.26%", src: motif35, transform: "rotate(180deg)" },
  { top: "0.01%", right: "64.56%", bottom: "1.02%", left: "34.85%", src: motif40, transform: "rotate(180deg)" },
  { top: "0.01%", right: "35.43%", bottom: "1.02%", left: "63.98%", src: motif40, transform: "rotate(180deg)" },
  { top: "0.01%", right: "78.8%", bottom: "1.02%", left: "20.61%", src: motif36, transform: "rotate(180deg)" },
  { top: "0.01%", right: "57.74%", bottom: "1.02%", left: "41.67%", src: motif36, transform: "rotate(180deg)" },
  { top: "0.01%", right: "66.48%", bottom: "1.02%", left: "32.93%", src: motif37, transform: "rotate(180deg)" },
  { top: "0.01%", right: "37.35%", bottom: "1.02%", left: "62.06%", src: motif37, transform: "rotate(180deg)" },
  { top: "0.01%", right: "69.69%", bottom: "1.02%", left: "29.72%", src: motif38, transform: "rotate(180deg)" },
  { top: "0.01%", right: "40.56%", bottom: "1.02%", left: "58.85%", src: motif38, transform: "rotate(180deg)" },
  { top: "0.02%", right: "25.41%", bottom: "1.02%", left: "74%", src: motif14 },
  { top: "0.02%", right: "26.74%", bottom: "1.02%", left: "72.37%", src: motif12, transform: "scaleX(-1)" },
  { top: "0.02%", right: "26.07%", bottom: "1.02%", left: "73.33%", src: motif15 },
  { top: "0", right: "22.89%", bottom: "1.01%", left: "75.93%", src: motif21, transform: "rotate(180deg)" },
  { top: "0.02%", right: "24.15%", bottom: "1.02%", left: "74.67%", src: motif27 },
  { top: "0.02%", right: "9.04%", bottom: "1.02%", left: "89.77%", src: motif08 },
  { top: "0", right: "14.82%", bottom: "1.01%", left: "84%", src: motif05 },
  { top: "0.02%", right: "12.89%", bottom: "1.02%", left: "86.52%", src: motif07 },
  { top: "0.02%", right: "4.8%", bottom: "1.02%", left: "94.61%", src: motif14 },
  { top: "0.02%", right: "18%", bottom: "1.02%", left: "81.41%", src: motif03 },
  { top: "0.02%", right: "16.74%", bottom: "1.02%", left: "82.07%", src: motif04, transform: "scaleX(-1)" },
  { top: "0.02%", right: "21.63%", bottom: "1.02%", left: "77.18%", src: motif10 },
  { top: "0.01%", right: "13.56%", bottom: "1.02%", left: "85.26%", src: motif06, transform: "rotate(180deg)" },
  { top: "0.02%", right: "10.97%", bottom: "1.02%", left: "87.85%", src: motif17 },
  { top: "0.02%", right: "7.76%", bottom: "1.02%", left: "91.03%", src: motif09 },
  { top: "0.02%", right: "19.33%", bottom: "1.02%", left: "79.78%", src: motif11 },
  { top: "0.02%", right: "6.13%", bottom: "1.02%", left: "92.98%", src: motif12, transform: "scaleX(-1)" },
  { top: "0.02%", right: "20.3%", bottom: "1.02%", left: "79.11%", src: motif02 },
  { top: "0.02%", right: "20.96%", bottom: "1.02%", left: "78.44%", src: motif01 },
  { top: "0.02%", right: "5.46%", bottom: "1.02%", left: "93.94%", src: motif15 },
  { top: "0.02%", right: "18.67%", bottom: "1.02%", left: "80.74%", src: motif13 },
  { top: "0.02%", right: "12.23%", bottom: "1.02%", left: "87.18%", src: motif39 },
  { top: "0.02%", right: "16.08%", bottom: "1.02%", left: "83.33%", src: motif18 },
  { top: "0.02%", right: "10.3%", bottom: "1.02%", left: "89.11%", src: motif19 },
  { top: "0.02%", right: "7.09%", bottom: "1.02%", left: "92.31%", src: motif16 },
  { top: "0", right: "2.28%", bottom: "1.01%", left: "96.54%", src: motif21, transform: "rotate(180deg)" },
  { top: "0.02%", right: "3.54%", bottom: "1.02%", left: "95.28%", src: motif27 },
  { top: "1.04%", right: "0", bottom: "0", left: "99.11%", src: motif31, transform: "scaleX(-1) rotate(180deg)" },
  { top: "1.04%", right: "1.61%", bottom: "0", left: "97.79%", src: motif32, transform: "rotate(180deg)" },
  { top: "1.04%", right: "0.95%", bottom: "0", left: "98.46%", src: motif33, transform: "rotate(180deg)" },
];

const HihHeaderRibbon = () => (
  <div className="hih-header-ribbon" aria-hidden="true">
    <div className="hih-header-ribbon-canvas">
      {MOTIFS.map((motif, index) => {
        const wrapStyle: CSSProperties = {
          position: "absolute",
          top: motif.top,
          right: motif.right,
          bottom: motif.bottom,
          left: motif.left,
          transform: motif.transform,
          overflow: "hidden",
        };
        return (
          <div key={index} style={wrapStyle} className="hih-header-ribbon-slot">
            <img src={motif.src} alt="" className="hih-header-ribbon-motif" />
          </div>
        );
      })}
    </div>
  </div>
);

export default HihHeaderRibbon;
